<template>
    <div id="opportunity-form" class="salesforce-opportunity-form">
        <DxValidationGroup>
            <div class="form-toolbar">
                <ToolbarForm :is-editing="isEditing" @edit-canceled="cancelEdit()" @edit-toggled="startEdit()"
                    @save-clicked="handleSaveClick" />
            </div>

            <DxLoadPanel :show-pane="false" width="auto" container="#opportunity-form"
                :position="{ of: '#opportunity-form' }" />

            <div class="form-cards-container">

                <div class="info-card" :class="{ 'collapsed': !expandedSections.general }">
                    <div class="card-section-header" @click="toggleSection('general')">
                        <i class="dx-icon-info"></i>
                        <h3>Informații Generale</h3>
                        <i class="expand-icon"
                            :class="expandedSections.general ? 'dx-icon-chevrondown' : 'dx-icon-chevronright'"></i>
                    </div>
                    <div class="card-grid" v-show="expandedSections.general">
                        <div class="field-group">
                            <label class="field-label">Nume</label>
                            <FormTextbox v-model="opportunityData.Nume" :is-editing="isEditing" :show-label="false"
                                :validators="(defaultValidators as any)" />
                        </div>
                        <div class="field-group">
                            <label class="field-label">Prenume</label>
                            <FormTextbox v-model="opportunityData.Prenume" :is-editing="isEditing" :show-label="false"
                                :validators="(defaultValidators as any)" />
                        </div>

                        <div class="field-group">
                            <label class="field-label">Funcția</label>
                            <FormTextbox v-model="opportunityData.Titlu" :is-editing="isEditing" :show-label="false"
                                :validators="(defaultValidators as any)" />
                        </div>


                        <!-- <div class="field-group">
                            <label class="field-label">Prenume</label>
                            <FormTextbox v-model="opportunityData.Prenume" :is-editing="isEditing"
                                :show-label="false" />
                        </div> -->

                        <div class="field-group">
                            <label class="field-label">Partener</label>
                            <DxDropDownBox v-model="opportunityData.AccountID" :data-source="dsParteneri"
                                display-expr="Nume" value-expr="ID" :read-only="true"
                                v-model:opened="isParteneriGridBoxOpened" :show-clear-button="true"
                                :drop-down-options="{ width: 450 }">
                                <DxValidator>
                                    <DxRequiredRule message="Compania este obligatorie" />
                                </DxValidator>
                                <template #content>
                                    <DxDataGrid :data-source="dsParteneri" :columns="['Nume']"
                                        :hover-state-enabled="true" height="100%"
                                        @selection-changed="onValueSelectedPartener">
                                        <DxSelection mode="single" />

                                        <DxFilterRow :visible="true" />
                                        <DxScrolling mode="virtual" />
                                        <DxSearchPanel :visible="true" placeholder="Caută partener..." />
                                    </DxDataGrid>
                                </template>
                            </DxDropDownBox>
                        </div>

                        <div class="field-group">
                            <label class="field-label">Metodă de comunicare</label>
                            <DxSelectBox :items="metodaContact" v-model:value="opportunityData.MetodaContact"
                                :read-only="!isEditing" placeholder="Selectează metoda...">
                                <DxValidator>
                                    <DxRequiredRule message="Metoda de comunicare este obligatorie" />
                                </DxValidator>
                            </DxSelectBox>
                        </div>
                        <div class="field-group">
                            <label class="field-label">Email</label>
                            <FormTextbox v-model="opportunityData.Email" :is-editing="isEditing" :show-label="false"
                                :validators="(emailValidators as any)" />
                        </div>
                        <!-- 
                        <div class="field-group">
                            <label class="field-label">Responsabil</label>
                            <FormTextbox v-model="opportunityData.Owner" :is-editing="false" :show-label="false" />
                        </div> -->
                        <!-- <div class="field-group">
                            <label class="field-label">Telefon</label>
                            <FormTextbox v-model="opportunityData.TelMunca" :is-editing="isEditing"
                                :show-label="false" />
                        </div> -->
                        <div class="field-group">
                            <label class="field-label">Telefon</label>
                            <FormTextbox v-model="opportunityData.TelMobil" :is-editing="isEditing" :show-label="false"
                                :validators="(phoneValidators as any)" />
                        </div>

                        <!-- <div class="field-group ">
                            <label class="field-label">Email Marketing</label>
                            <DxCheckBox v-model="opportunityData.EmailMarketing" :read-only="!isEditing"
                                :validators="optionalValidators" />
                        </div>
                        <div class="field-group ">
                            <label class="field-label">SMS Marketing</label>
                            <DxCheckBox v-model="opportunityData.SmsMarketing" :read-only="!isEditing"
                                :validators="optionalValidators" />
                        </div> -->
                    </div>
                </div>

                <div class="info-card" :class="{ 'collapsed': !expandedSections.financial }">
                    <div class="card-section-header" @click="toggleSection('financial')">
                        <i class="dx-icon-home"></i>
                        <h3>Detalii</h3>
                        <i class="expand-icon"
                            :class="expandedSections.financial ? 'dx-icon-chevrondown' : 'dx-icon-chevronright'"></i>
                    </div>
                    <div class="card-grid" v-show="expandedSections.financial">

                        <div class="field-group field-full">
                            <label class="field-label">Adresa</label>
                            <FormTextbox v-model="opportunityData.Adresa" :is-editing="isEditing"
                                :validators="optionalValidators" />
                        </div>

                        <div class="field-group">
                            <label class="field-label">Țară</label>
                            <DxDropDownBox v-model="opportunityData.TaraID" :data-source="dsTari" display-expr="Nume"
                                value-expr="ID" :read-only="!isEditing" v-model:opened="isTaraGridBoxOpened"
                                :show-clear-button="true" :drop-down-options="{ width: 400, minWidth: 300 }">
                                <template #content>
                                    <div style="padding: 5px;">
                                        <DxDataGrid :data-source="dsTari" :columns="['Nume']"
                                            :hover-state-enabled="true" :height="250"
                                            @selection-changed="onValueSelectedTara">
                                            <DxSelection mode="single" />
                                            <DxPaging :enabled="true" :page-size="10" />
                                            <DxFilterRow :visible="true" />
                                            <DxSearchPanel :visible="true" placeholder="Caută țara..." />
                                        </DxDataGrid>
                                    </div>
                                </template>
                            </DxDropDownBox>
                        </div>

                        <div class="field-group">
                            <label class="field-label">Județ</label>
                            <DxDropDownBox v-model="opportunityData.JudetID" :data-source="dsJudete" display-expr="Nume"
                                value-expr="ID" :read-only="!isEditing" v-model:opened="isJudetGridBoxOpened"
                                :show-clear-button="true" :drop-down-options="{ width: 450 }">
                                <template #content>
                                    <div style="padding: 10px;">
                                        <DxDataGrid :data-source="dsJudete" :columns="['Nume']"
                                            :hover-state-enabled="true" :height="300"
                                            @selection-changed="onValueSelectedJudet">
                                            <DxSelection mode="single" />
                                            <DxPaging :enabled="true" :page-size="10" />
                                            <DxFilterRow :visible="true" />
                                            <DxSearchPanel :visible="true" placeholder="Caută județ..." />
                                        </DxDataGrid>
                                    </div>
                                </template>
                            </DxDropDownBox>
                        </div>


                        <div class="field-group">
                            <label class="field-label">Localitate</label>
                            <DxDropDownBox v-model="opportunityData.LocalitateID" :data-source="dsLocalitati"
                                display-expr="Localitate" value-expr="ID" :read-only="!isEditing"
                                v-model:opened="isLocalitateGridBoxOpened" :show-clear-button="true"
                                :drop-down-options="{ width: 450 }">
                                <template #content>
                                    <div style="padding: 10px;">
                                        <DxDataGrid :data-source="dsLocalitati" :columns="['Localitate']"
                                            :hover-state-enabled="true" :height="300"
                                            @selection-changed="onValueSelectedLocalitate">
                                            <DxSelection mode="single" />
                                            <DxPaging :enabled="true" :page-size="10" />
                                            <DxFilterRow :visible="true" />
                                            <DxSearchPanel :visible="true" placeholder="Caută localitate..." />
                                        </DxDataGrid>
                                    </div>
                                </template>
                            </DxDropDownBox>
                        </div>


                        <div class="field-group">
                            <label class="field-label">Observații</label>
                            <FormTextbox v-model="opportunityData.Note" :is-editing="isEditing"
                                :validators="optionalValidators" />
                        </div>
                    </div>
                </div>

            </div>
        </DxValidationGroup>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { DxButton } from 'devextreme-vue/button';
import DxLookup from "devextreme-vue/lookup"
import { DxCheckBox } from 'devextreme-vue/check-box';
import {
    DxForm,
    DxItem as DxFormItem,
    DxGroupItem as DxFormGroupItem,
    DxColCountByScreen,
} from 'devextreme-vue/form';
import { DxNumberBox } from 'devextreme-vue/number-box';
import { DxValidator, DxRequiredRule } from 'devextreme-vue/validator';
import { DxValidationGroup } from 'devextreme-vue/validation-group';
import DxLoadPanel from 'devextreme-vue/load-panel';
import ToolbarForm from '@/components/utils/toolbar-form.vue';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '../../settings/appSettings'
import FormTextbox from '../utils/form-textbox.vue';
import DxSelectBox from "devextreme-vue/select-box"
import DxDateBox from "devextreme-vue/date-box"
import DataSource from "devextreme/data/data_source";
import DxDropDownBox from "devextreme-vue/drop-down-box";
import {
    DxDataGrid,
    DxPaging,
    DxSelection,
    DxSearchPanel,
    DxFilterRow,
} from 'devextreme-vue/data-grid';
import CrmContacts from '@/services/Comercial/CrmContacts';

export default defineComponent({
    components: {
        DxForm,
        DxFormItem,
        DxFormGroupItem,
        DxColCountByScreen,
        DxNumberBox,
        DxValidator,
        DxRequiredRule,
        DxValidationGroup,
        DxLoadPanel,
        FormTextbox,
        ToolbarForm,
        DxButton,
        DxSelectBox,
        DxLookup,
        DxDateBox,
        DxDropDownBox,
        DxDataGrid,
        DxPaging,
        DxSelection,
        DxSearchPanel,
        DxFilterRow,
        DxCheckBox
    },
    props: {
        opportunityData: {
            type: Object,
            required: true
        },
        isEditing: {
            type: Boolean,
            default: false
        },
        isLoading: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            dsCampanii: {} as any,
            isCampanieGridBoxOpened: false,
            sCampanie: null,
            dsSales: null,
            isEditing: false,
            isParteneriGridBoxOpened: false,
            dsParteneri: {} as any,
            sPartener: null,
            sIndustrie: null,
            dsIndustrii: {} as any,
            isIndustrieGridBoxOpened: false,
            dsContacts: {} as any,
            sContact: null,
            isContacteGridBoxOpened: false,
            expandedSections: {
                general: true,
                financial: false,
                timeline: false,
                additional: false
            },
            isSursaGridBoxOpened: false,
            isTaraGridBoxOpened: false,
            isJudetGridBoxOpened: false,
            isLocalitateGridBoxOpened: false,
            sSalesSources: null,
            dsSalesSources: {} as any,
            dsTari: {} as any,
            dsJudete: {} as any,
            dsLocalitati: {} as any,
            metodaContact: ['Telefonic', 'Email'],
        }
    },
    computed: {
        defaultValidators() {
            return [{ type: 'required', message: 'Acest câmp este obligatoriu' }];
        },
        optionalValidators() {
            return [];
        },
        emailValidators() {
            if (this.opportunityData.MetodaContact === 'Email') {
                return [
                    { type: 'required', message: 'Email-ul este obligatoriu' },
                    { type: 'email', message: 'Email invalid' }
                ];
            }
            return [];
        },
        phoneValidators() {
            if (this.opportunityData.MetodaContact === 'Telefonic') {
                return [{ type: 'required', message: 'Telefonul este obligatoriu' }];
            }
            return [];
        }
    },
    methods: {
        createODataContext() {
            this.dsContacts = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'CRM_Contacts',
                    key: 'ID',
                    keyType: "Guid",
                    version: 4,
                    beforeSend: (e: any) => {
                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                        };
                    }
                },
                select: ['ID', 'Nume'],
            });



            this.dsSales = new ODataStore({
                url: AppSetting.API_Url_ComercialOdata + 'CRM_Sales',
                key: 'ID',
                keyType: "Guid",
                version: 4,
                beforeSend: (e) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt"),
                    };
                }
            });

            this.dsParteneri = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'PAR_Parteneri',
                    key: 'ID',
                    keyType: "Guid",
                    version: 4,
                    beforeSend: (e: any) => {
                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                        };
                    }
                },
                select: ['ID', 'Nume'],
            });

            this.dsSalesSources = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'CRM_SalesSources',
                    key: 'ID',
                    version: 4,
                    beforeSend: (e: any) => {
                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                        };
                    }
                },
                select: ['ID', 'Nume'],
            });

            this.dsCampanii = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'CRM_CautareCampaniiMarketing',
                    key: 'ID',
                    keyType: "Guid",
                    version: 4,
                    beforeSend: (e: any) => {
                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                        };
                    }
                },
                select: ['ID', 'Denumire'],
            });
            this.dsTari = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'ERP_Tari',
                    key: 'ID',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };
                    }
                },
                select: [
                    'ID',
                    'Nume',
                ],

            });
            this.dsJudete = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'ERP_Judete',
                    key: 'ID',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };
                    }
                },
                select: [
                    'ID',
                    'Nume',
                ],

            });
            this.dsLocalitati = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'ERP_Localitati',
                    key: 'ID',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };
                    }
                },
                select: [
                    'ID',
                    'Localitate',
                ],

            });
        },
        onValueSelectedTara(e) {
            this.isTaraGridBoxOpened = false;
            const selectedTaraId = e.selectedRowKeys[0] || null;

            // SCHIMBĂ AICI: folosește opportunityData (ca în HTML) în loc de contactData
            if (this.opportunityData) {
                this.opportunityData.TaraID = selectedTaraId;
            }

            this.sTara = selectedTaraId;

            // Filtrarea județelor rămâne valabilă
            if (this.dsJudete) {
                const _filter = selectedTaraId ? ["TaraId", "=", selectedTaraId] : null;
                this.dsJudete.filter(_filter);
                this.dsJudete.load();
            }
        },
        onValueSelectedJudet(e) {
            this.isJudetGridBoxOpened = false;

            const selectedJudetId = e.selectedRowKeys[0] || null;

            if (this.opportunityData) {
                this.opportunityData.JudetID = selectedJudetId;
            }

            const _filter = selectedJudetId ? ["JudetId", "=", selectedJudetId] : null;

            this.dsLocalitati.filter(_filter);
            this.dsLocalitati.load();
        },
        onValueSelectedLocalitate(e) {
            this.isLocalitateGridBoxOpened = false;

            // Luăm ID-ul selectat
            const selectedLocalitateId = e.selectedRowKeys[0] || null;

            // Salvează în obiectul corect (cel folosit în v-model-ul de la DropDownBox)
            if (this.opportunityData) {
                this.opportunityData.LocalitateID = selectedLocalitateId;
            } else {
                console.error("Obiectul opportunityData nu este inițializat!");
            }
        },
        onValueSelectedPartener(e) {
            const selected = e.selectedRowsData[0];
            this.opportunityData.AccountID = selected ? selected.ID : null;
            this.isParteneriGridBoxOpened = false;
            const _filter = selected ? ["AccountId", "=", selected.ID] : null;
            this.dsContacts.filter(_filter);
            this.dsContacts.load();
        },
        onValueSelectedCampanie(e) {
            this.isCampanieGridBoxOpened = false;
            if (e.selectedRowKeys.length > 0) {
                this.sCampanie = e.selectedRowKeys[0];
            } else {
                this.sCampanie = null;
            }
            this.formData.CampanieID = this.sCampanie;
        },
        onValueSelectedContact(e) {
            this.isContacteGridBoxOpened = false;
            if (e.selectedRowKeys.length > 0) {
                this.sContact = e.selectedRowKeys[0];
            } else {
                this.sContact = null;
            }
            this.formData.ContactID = this.sContact;
        },
        onValueSelectedIndustrie(e) {
            this.isIndustrieGridBoxOpened = false;
            if (e.selectedRowKeys.length > 0) {
                this.sIndustrie = e.selectedRowKeys[0];
            } else {
                this.sIndustrie = null;
            }
            this.formData.IndustrieID = this.sIndustrie;
        },
        onValueSelectedSursa(e) {
            this.isSursaGridBoxOpened = false;
            if (e.selectedRowKeys.length > 0) {
                this.sSalesSources = e.selectedRowKeys[0];
            } else {
                this.sSalesSources = null;
            }
            this.formData.SursaID = this.sSalesSources;
        },
        toggleSection(section: string) {
            this.expandedSections[section] = !this.expandedSections[section];
        },
        startEdit() {
            this.isEditing = true;
        },
        cancelEdit() {
            this.isEditing = false;
        },
        handleSaveClick({ validationGroup }) {
            const result = validationGroup.validate();
            if (!result.isValid) {
                console.warn('Formular invalid:', result);
                return;
            }
            if (!this.opportunityData.ID) {
                console.warn('Lipsește ID-ul contactului.');
                return;
            }
            console.log('Salvez:', this.opportunityData);
            CrmContacts
                .update(this.opportunityData.ID, this.opportunityData)
                .then(() => {
                    console.log('Salvare reușită!');
                    this.$emit('saved', this.opportunityData);
                    this.isEditing = false;
                })
                .catch((err) => {
                    console.error('Eroare la salvare:', err);
                });
        }
    },
    mounted() {
        this.createODataContext();
    },
});
</script>

<style scoped lang="scss">
.salesforce-opportunity-form {
    position: relative;
}

.form-toolbar {
    margin-bottom: 0.5rem;
    display: flex;
    justify-content: flex-end;
    padding-bottom: 1rem;
    border-bottom: 1px solid #e5e7eb;
}

.form-cards-container {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

/* Info Card Styling */
.info-card {
    background: white;
    border-radius: 8px;
    border: 1px solid #e5e7eb;
    overflow: hidden;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.card-section-header {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 1rem 1.5rem;
    background: linear-gradient(to bottom, #fafafa 0%, #f5f5f5 100%);
    border-bottom: 1px solid #e5e7eb;
    cursor: pointer;
    user-select: none;
    transition: all 0.2s ease;

    &:hover {
        background: linear-gradient(to bottom, #f5f5f5 0%, #efefef 100%);
    }

    i {
        font-size: 18px;
        color: #6b7280;
    }

    h3 {
        margin: 0;
        font-size: 15px;
        font-weight: 600;
        color: #111827;
        letter-spacing: -0.01em;
        flex: 1;
    }

    .expand-icon {
        font-size: 14px;
        color: #9ca3af;
        transition: transform 0.2s ease;
        margin-left: auto;
    }
}

.info-card.collapsed {
    .card-section-header {
        border-bottom: none;
    }
}

.card-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.85rem;
    padding: 1.5rem;
    transition: all 0.3s ease;
}

.field-group {
    display: flex;
    flex-direction: column;


    &.full-width {
        grid-column: 1 / -1;
    }
}

.field-label {
    font-size: 12px;
    font-weight: 500;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.025em;
    margin-bottom: 2px;
}

/* DevExtreme Input Overrides */
::v-deep(.dx-texteditor) {
    border-radius: 4px;
    border-color: #d1d5db;
    background: white;

    &.dx-state-readonly {
        background: #f9fafb;
        border-color: #e5e7eb;
    }

    &.dx-state-focused {
        border-color: #3b82f6;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }

    &.dx-state-hover:not(.dx-state-readonly) {
        border-color: #9ca3af;
    }
}

::v-deep(.dx-texteditor-input) {
    padding: 8px 12px;
    font-size: 14px;
    color: #111827;
    min-height: 38px;
}

::v-deep(.dx-dropdowneditor-button) {
    border-left: 1px solid #e5e7eb;
}

/* Responsive */
@media (max-width: 768px) {
    .card-grid {
        grid-template-columns: 1fr;
        gap: 1rem;
        padding: 1rem;
    }

    .field-group.full-width {
        grid-column: 1;
    }
}

.field-full {
    grid-column: 1 / -1;
}
</style>
